<template>
  <div>
    <el-form ref="eqInsForm" :rules="rules" :model="addFormExtend" label-width="120px">
      <el-form-item label="巡检任务名称" prop="name">
        <el-input
          v-model="addFormExtend.name"
          placeholder="请输入内容" maxlength="100"
        ></el-input>
      </el-form-item>
      <el-form-item label="巡检时间" prop="timeRange">
        <el-date-picker
          is-range
          v-model="addFormExtend.timeRange"
          type="datetimerange"
          range-separator="~"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="handleTimeFormat"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleAddDevice">新增设备标准</el-button>
      </el-form-item>
      <el-form-item>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="name" label="名称" width="180">
          </el-table-column>
          <el-table-column prop="displayName" label="巡检标准">
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>

    <!--  -->
    <el-dialog
      title="新增设备标准"
      :visible.sync="dialogVisible"
      append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @before-close="beforeClose"
    >
      <el-form label-width="120px">
        <el-form-item label="选择设备">
          <el-select
            v-model="deviceId"
            placeholder="请选择"
            @change="handledeviceChange"
          >
            <el-option
              v-for="(item, index) in deviceList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择标准">
          <el-select v-model="deviceContentIds" multiple placeholder="请选择">
            <el-option
              v-for="item in allContents"
              :key="item.value"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmContents">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDeviceQueryList,
  getDeviceInspectStandard,
} from "@/api/crmedical/order/order-add";
import dayjs from "dayjs";
import { vString } from "@/util/validate";
export default {
  props: ["addFormExtend", "projectId"],
  data() {
    return {
      rules: {
        name: [
          { required: true, message: "请输入任务名称", trigger: "change" },
          { validator: vString("任务名称"), trigger: "change" },
        ],
        timeRange: [
          { required: true, message: "请选择巡检时间", trigger: "change" },
        ],
      },
      deviceList: [],
      deviceId: "",
      deviceContentIds: [],
      deviceContents: [],
      allContents: [],
      choosenData: {},
      tableData: [],
      dialogVisible: false,
    };
  },
  watch: {
    projectId: function () {
      if (this.projectId) {
        this.deviceList = [];
        this.addFormExtend.deviceId = "";
        this.choosenData = {};
        this.tableData = [];
        this.deviceId = "";
        this.deviceContentIds = [];
        this.deviceContents = [];
        this.allContents = [];
        this.loadDeviceList();
      }
    },
  },
  methods: {
    validate() {
      return new Promise((res, rej) => {
        this.$refs.eqInsForm.validate((valid) => {
          if (valid) {
            if (this.addFormExtend.list && this.addFormExtend.list.length > 0) {
              res(true);
            } else {
              this.$message.error("请选择一个设备");
              res(false);
            }
          } else {
            res(false);
          }
        });
      });
    },
    // 新增弹窗
    handleAddDevice() {
      this.deviceId = "";
      this.deviceContentIds = [];
      this.deviceContents = [];
      this.allContents = [];
      this.dialogVisible = true;
    },
    getDeviceName(val) {
      let name = "";
      this.deviceList.forEach((item) => {
        if (item.id == val) {
          name = item.name;
        }
      });
      return name;
    },
    // 选择变化
    handledeviceChange() {
      if (this.alreadySelectedCheck(this.deviceId)) {
        this.$message.error("该设备已选择");
      }
      this.deviceContentIds = [];
      this.deviceContents = [];
      this.loadDeviceInspectStandard();
    },
    // 时间范围格式化
    handleTimeFormat(v) {
      console.log("this.addFormExtend:=>", this.addFormExtend);
      if (this.addFormExtend.timeRange) {
        console.log('123:=>',123);
        
        let s = dayjs(this.addFormExtend.timeRange[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        let e = dayjs(this.addFormExtend.timeRange[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.addFormExtend.time = `${s}~${e}`;
      }
    },
    // 获取设备列表
    loadDeviceList() {
      getDeviceQueryList({ projectId: this.projectId }).then((res) => {
        if (res.success) {
          this.deviceList = res.data;
        }
      });
    },
    // 获取设备标准
    loadDeviceInspectStandard() {
      getDeviceInspectStandard({ deviceId: this.deviceId }).then((res) => {
        console.log("res getDeviceInspectStandard==>", res);
        if (res.success) {
          this.allContents = res.data;
        }
      });
    },
    confirmContents() {
      if (this.alreadySelectedCheck(this.deviceId)) {
        this.$message.error("该设备已选择");
        return false;
      }
      if (this.deviceContentIds.length > 0) {
        this.deviceContents = this.allContents.filter((item) =>
          this.deviceContentIds.includes(item.id)
        );
        this.choosenData[this.deviceId] = {};
        this.choosenData[
          this.deviceId
        ].deviceContentIds = this.deviceContentIds;
        this.choosenData[this.deviceId].deviceContents = this.deviceContents;
      }
      this.dialogVisible = false;
      //
      this.buildTableData();
    },
    alreadySelectedCheck(id) {
      return !!this.choosenData[id];
    },
    buildTableData() {
      // list 是后台需要的数据结构
      let list = [];
      // 构建tableData,tableData是前端展示的数据结构
      let tableData = [];
      for (let key in this.choosenData) {
        let oneDevice = {};
        oneDevice.name = this.getDeviceName(key);
        oneDevice.displayName = "";
        this.choosenData[key].deviceContents.forEach((item) => {
          oneDevice.displayName += `${item.name}；`;
          list.push({ deviceId: key, content: item.content });
        });
        tableData.push(oneDevice);
      }
      //
      this.addFormExtend.list = list;
      this.tableData = tableData;
    },
  },
  created() {
    this.loadDeviceList();
  },
};
</script>
<style>
</style>